import React from 'react';

import useChatAppearance from '../../../hooks/useChatAppearance';
import SettingsSection from './SettingsSection';
import './PersonalizationSettings.css';

export const DISPLAY_SECTION_ID = 'display';

export const THEME_OPTIONS = [
  { id: 'light', label: '밝게' },
  { id: 'dark', label: '어둡게' },
  { id: 'system', label: '기기 설정 따르기' },
];

/**
 * AI 맞춤 설정의 "화면" 섹션: 화면 모드(밝게/어둡게/기기 설정)와 단순하게 보기.
 * 기기 저장(localStorage)이라 로그인 없이도 보여준다.
 */
const DisplaySettingsSection = ({ open, onToggle }) => {
  const {
    darkModeAvailable,
    setSimple,
    setTheme,
    simple,
    simpleViewAvailable,
    theme,
  } = useChatAppearance();

  if (!darkModeAvailable && !simpleViewAvailable) return null;

  return (
    <SettingsSection
      description="어둡게 보기와 단순하게 보기를 이 기기에 저장해요"
      id={DISPLAY_SECTION_ID}
      onToggle={onToggle}
      open={open}
      title="화면"
    >
      {darkModeAvailable && (
        <div className="csettings-display-block">
          <div className="csettings-master-title" id="csettings-theme-label">
            화면 모드
          </div>
          <div
            aria-labelledby="csettings-theme-label"
            className="csettings-segment"
            role="radiogroup"
          >
            {THEME_OPTIONS.map((option) => {
              const active = option.id === theme;
              return (
                <button
                  aria-checked={active}
                  className={`csettings-segment__item ${active ? 'is-active' : ''}`}
                  key={option.id}
                  onClick={() => setTheme(option.id)}
                  role="radio"
                  type="button"
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>
      )}

      {simpleViewAvailable && (
        <div className="csettings-master-row csettings-master-row--flat">
          <div>
            <div className="csettings-master-title">단순하게 보기</div>
            <div className="csettings-master-caption">
              다음 질문 추천, 둘러보기 카드, 모델 이름 같은 부가 표시를 숨겨요.
              복사·다시 만들기·멈춤은 그대로예요.
            </div>
          </div>
          <button
            aria-checked={simple}
            aria-label="단순하게 보기"
            className={`personalization-switch ${simple ? 'is-on' : ''}`}
            onClick={() => setSimple(!simple)}
            role="switch"
            type="button"
          >
            <span className="personalization-switch-knob" />
          </button>
        </div>
      )}
    </SettingsSection>
  );
};

export default DisplaySettingsSection;
